/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SqlEngineStatus } from '../models/SqlEngineStatus';

export class SqlEngine {
  /**
  * The unique identifier of the SQL engine
  */
  'id': string;
  /**
  * The name of the SQL engine
  */
  'name': string;
  /**
  * The type of the SQL engine (deployment-determined)
  */
  'engineType': string;
  'status': SqlEngineStatus;
  /**
  * The timestamp when the SQL engine was created
  */
  'createdAt': Date;
  /**
  * Number of worker nodes
  */
  'workerCount': number;
  /**
  * Worker node size profile
  */
  'workerSize': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "engineType",
      "baseName": "engineType",
      "type": "string",
      "format": ""
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "SqlEngineStatus",
      "format": ""
    },
    {
      "name": "createdAt",
      "baseName": "createdAt",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "workerCount",
      "baseName": "workerCount",
      "type": "number",
      "format": ""
    },
    {
      "name": "workerSize",
      "baseName": "workerSize",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SqlEngine.attributeTypeMap;
  }

  public constructor() {
  }
}



